export default __webpack_public_path__ + "static/media/aj10.66d371f3.png";